import {useQuery} from "react-query";
import {SearchResourceRequest} from "../../models/drive";
import resourceService from "../../services/ResourceService";

export default function useResources(request?: SearchResourceRequest, disabled?: boolean) {
   return useQuery(['resources', request], () => resourceService.search(request), {
      enabled: !!request?.spaceId && !disabled
   });
}